import {NAV_MAIN_ELEMENTS} from "../constants/navigation_elements";
import {INavLeftElement} from "../Navigation";

export const buildNavElements = (base?: string) => {
    if (base) {
        return changeNavLinks(NAV_MAIN_ELEMENTS, base);
    }
    return NAV_MAIN_ELEMENTS;
};

const changeNavLinks = (navElements: INavLeftElement[], linkBase: string): INavLeftElement[] => {
    return navElements.map((element) => {
        const elementUrl = element.url || "";
        const newUrl = elementUrl.includes("https") ? elementUrl : linkBase.concat(elementUrl);
        if (element.subElements) {
            return {...element, url: newUrl, subElements: changeNavLinks(element.subElements, linkBase)};
        }

        return {...element, url: newUrl};
    });
};
import {NAV_MAIN_ELEMENTS} from "../constants/navigation_elements";
import {INavLeftElement} from "../Navigation";

export const buildNavElements = (base?: string) => {
    if (base) {
        return changeNavLinks(NAV_MAIN_ELEMENTS, base);
    }
    return NAV_MAIN_ELEMENTS;
};

const changeNavLinks = (navElements: INavLeftElement[], linkBase: string): INavLeftElement[] => {
    return navElements.map((element) => {
        const elementUrl = element.url || "";
        const newUrl = elementUrl.includes("https") ? elementUrl : linkBase.concat(elementUrl);
        if (element.subElements) {
            return {...element, url: newUrl, subElements: changeNavLinks(element.subElements, linkBase)};
        }

        return {...element, url: newUrl};
    });
};
